import type { PlayerProfileResponse } from '@on3/api';
import { CompactHeader } from 'components/Db/Profile/Header/CompactHeader';
import { DatabaseLayout } from 'components/Layouts/DatabaseLayout';
import { Pagination } from 'components/UI/Pagination/Pagination';
import { useRouter } from 'next/router';
import { useState } from 'react';

import {
  type IPhotosThumbnailListProps,
  PhotosThumbnailList,
} from '../PhotosThumbnailList/PhotosThumbnailList';
import styles from './PhotoGallery.module.scss';

export interface IPhotoGalleryProps extends IPhotosThumbnailListProps {
  basicInfo?: PlayerProfileResponse;
}

export const PhotoGallery = ({
  playerImages,
  basicInfo,
}: IPhotoGalleryProps) => {
  const { pagination } = playerImages || {};

  const router = useRouter();

  const paginationCount = pagination?.count || 0;
  const paginationPageCount = pagination?.pageCount || 1;
  const [pageNumber, setPageNumber] = useState(pagination?.currentPage || 1);

  const handleChange = (_event: any, page: any) => {
    setPageNumber(page);

    router.push({
      pathname: router.pathname,
      query: { ...router.query, page },
    });
  };

  return (
    <DatabaseLayout>
      <div className={styles.block}>
        <CompactHeader basicInfo={basicInfo} />

        <section>
          <h2 className={styles.title}>{`${basicInfo?.name} Photos`}</h2>
          <PhotosThumbnailList
            className={styles.photoGallery}
            playerImages={playerImages}
          />
          {paginationCount > 25 && (
            <Pagination
              count={paginationPageCount}
              onChange={handleChange}
              page={pageNumber}
            />
          )}
        </section>
      </div>
    </DatabaseLayout>
  );
};
